export type CustomModalProps = {
    render? : boolean,
    onOuterClick? : () => void,
    children?: JSX.Element | JSX.Element[];
}

export const CustomModal = (props: CustomModalProps) => {
    const onMouseUp = (event: any) => {
        if (event.target === event.currentTarget) {
            props.onOuterClick?.()
        }
    }

    return ( props.render ?
        <div className="modal-cover" onMouseUp={onMouseUp}>
            <div className="custom-modal">
                {props.children}
            </div>
        </div> : null
    )
}
